// Reusable Clinivon mark. The source image has a dark background baked in,
// so we render it as a contained square that looks intentional on both
// light navbars and the dark footer.

export const LOGO_SRC = "/clinivon-logo.jpg";

export function ClinivonMark({ size = 40, className = "" }) {
  return (
    <span
      className={`inline-block overflow-hidden rounded-sm shadow-sm ring-1 ring-black/10 ${className}`}
      style={{ width: size, height: size }}
    >
      <img
        src={LOGO_SRC}
        alt="Clinivon"
        width={size}
        height={size}
        className="block w-full h-full object-cover"
        loading="eager"
        decoding="async"
      />
    </span>
  );
}

export default ClinivonMark;
